import { Colors, Icon, IconName } from "@blueprintjs/core";

import { ComponentStatus } from "@/graphql";

export const COMPONENT_STATUS_STYLES: Record<
  ComponentStatus,
  {
    textColor?: string;
    color: string;
    icon: React.ReactNode;
    iconClass?: IconName;
    text: string;
    borderColor: string;
    backgroundColor?: string;
  }
> = {
  [ComponentStatus.NotStarted]: {
    textColor: "#778397",
    color: "#F5F6F8",
    icon: <Icon icon="circle" size={14} color={"#778397"} />,
    iconClass: "circle",
    text: "Not Started",
    borderColor: "#b0b6bf",
    backgroundColor: "#F2F4F8",
  },
  [ComponentStatus.Completed]: {
    color: "#129B4C",
    icon: <Icon icon="tick-circle" size={14} color={"#0D8050"} />,
    iconClass: "tick-circle",
    text: "Completed",
    borderColor: "#129B4C",
    backgroundColor: "#E6F5EF",
  },
  [ComponentStatus.Started]: {
    textColor: "#215DB0",
    color: "#BED9FC",
    icon: <Icon icon="circle" size={14} color={"#215DB0"} />,
    iconClass: "circle",
    text: "Started",
    borderColor: "#40B1FF",
    backgroundColor: "#E9F1FB",
  },
  [ComponentStatus.DidNotFinish]: {
    textColor: "#C61D1D",
    color: "#C61D1D",
    icon: <Icon icon="cross-circle" size={14} color={"#C61D1D"} />,
    iconClass: "cross-circle",
    text: "Did Not Finish",
    borderColor: "#C61D1D",
    backgroundColor: "#F5E6E8",
  },
  [ComponentStatus.NoResponse]: {
    textColor: "#C61D1D",
    color: "#C61D1D",
    icon: <Icon icon="cross-circle" size={14} color={"#C61D1D"} />,
    iconClass: "cross-circle",
    text: "No Response",
    borderColor: "#C61D1D",
    backgroundColor: "#F5E6E8",
  },
  [ComponentStatus.PastDue]: {
    textColor: "#BF7326",
    color: "#BF7326",
    icon: <Icon icon="warning-sign" size={14} color={"#BF7326"} />,
    iconClass: "warning-sign",
    text: "Past Due",
    borderColor: "#BF7326",
    backgroundColor: "#FBF2E9",
  },
  [ComponentStatus.DidNotPass]: {
    textColor: "#C61D1D",
    color: "#C61D1D",
    icon: <Icon icon="warning-sign" size={14} color={"#C61D1D"} />,
    iconClass: "cross-circle",
    text: "Did Not Pass",
    borderColor: "#C61D1D",
    backgroundColor: "#F5E6E8",
  },
  [ComponentStatus.Missed]: {
    textColor: "#C61D1D",
    color: "#C61D1D",
    iconClass: "cross-circle",
    borderColor: "#C61D1D",
    backgroundColor: "#F5E6E8",
    icon: <Icon icon="cross-circle" size={14} color={"#C61D1D"} />,
    text: "Missed",
  },
  [ComponentStatus.InDesign]: {
    textColor: "#778397",
    color: "#778397",
    iconClass: "wrench",
    text: "In Design",
    borderColor: "#BF7326",
    backgroundColor: "#F2F4F8",
    icon: <Icon icon="wrench" className="text-subtext size-3.5" />,
  },
  [ComponentStatus.Ongoing]: {
    textColor: "#215DB0",
    color: "#215DB0",
    icon: <Icon icon="circle" size={14} color={"#215DB0"} />,
    iconClass: "circle",
    text: "Ongoing",
    borderColor: "#BF7326",
    backgroundColor: "#E9F1FB",
  },
  [ComponentStatus.Soon]: {
    textColor: "#BF7326",
    borderColor: "#BF7326",
    color: Colors.BLUE3,
    backgroundColor: "#E9F1FB",
    icon: <Icon icon="circle" size={14} color={"#215DB0"} />,
    text: "Soon",
  },
  [ComponentStatus.Upcoming]: {
    textColor: "#BF7326",
    color: "#BF7326",
    icon: <Icon icon="circle" size={14} color={"#BF7326"} />,
    iconClass: "circle",
    text: "Upcoming",
    borderColor: "#BF7326",
    backgroundColor: "#FBF2E9",
  },
};

export const TASK_TYPES = [
  { value: "TASK", name: "Task", helperText: "Manually marked as complete" },
  {
    value: "SINGLE_LINE",
    name: "Short Answer",
    helperText: "Provide a short answer prompt",
  },
  {
    value: "MULTI_LINE",
    name: "Long Answer",
    helperText: "Provide a detailed answer prompt",
  },
  {
    value: "URL",
    name: "URL Response",
    helperText: "Specify the URL to submit",
  },
  {
    value: "FILE",
    name: "File Upload",
    helperText: "Specify the file to upload",
  },
];
